export const FaqDataOne = [
    {
        id:"one",
        question:"What should I study for cybersecurity?",
        ans:`These services collectively help organizations establish a comprehensive
        cybersecurity framework and protect their digital assets from various cyber
        threats. This service focuses on securing end-user devices like.`,
    },
    {
        id:"two",
        question:"How do I choose a cybersecurity career?",
        ans:`These services collectively help organizations establish a comprehensive
        cybersecurity framework and protect their digital assets from various cyber
        threats. This service focuses on securing end-user devices like.`,
    },
    {
        id:"three",
        question:"Can I learn cyber security in 6 months?",
        ans:`These services collectively help organizations establish a comprehensive
        cybersecurity framework and protect their digital assets from various cyber
        threats. This service focuses on securing end-user devices like.`,
    },
    {
        id:"four",
        question:"What is the highest paying job in cyber security?",
        ans:`These services collectively help organizations establish a comprehensive
        cybersecurity framework and protect their digital assets from various cyber
        threats. This service focuses on securing end-user devices like.`,
    },
    {
        id:"five",
        question:"What is the lowest salary in cyber security?",
        ans:`Cybersecurity measures are put in place to ensure the confidentiality, integrity, and availability of information. These measures
        involve the use of hardware, software, and protocols to protect data and systems from unauthorized access and attacks. Common
        cybersecurity measures include firewalls, antivirus software, encryption programs,`,
    },
    {
        id:"six",
        question:"Who earns more computer science or data science?",
        ans:`These services collectively help organizations establish a comprehensive
        cybersecurity framework and protect their digital assets from various cyber
        threats. This service focuses on securing end-user devices like.`,
    },
    {
        id:"seven",
        question:"Who earns more data scientist or cyber security?",
        ans:`These services collectively help organizations establish a comprehensive
        cybersecurity framework and protect their digital assets from various cyber
        threats. This service focuses on securing end-user devices like.`,
    },
    {
        id:"eight",
        question:"Which is better in future data science or cyber security?",
        ans:`Cybersecurity measures are put in place to ensure the confidentiality, integrity, and availability of information. These measures
        involve the use of hardware, software, and protocols to protect data and systems from unauthorized access and attacks. Common
        cybersecurity measures include firewalls, antivirus software, encryption programs,`,
    },
    {
        id:"nine",
        question:"Who earns more data scientist or software engineer?",
        ans:`Cybersecurity measures are put in place to ensure the confidentiality, integrity, and availability of information. These measures
        involve the use of hardware, software, and protocols to protect data and systems from unauthorized access and attacks. Common
        cybersecurity measures include firewalls, antivirus software, encryption programs,`,
    },
    {
        id:"ten",
        question:"Which type of engineer makes the most money?",
        ans:`Cybersecurity measures are put in place to ensure the confidentiality, integrity, and availability of information. These measures
        involve the use of hardware, software, and protocols to protect data and systems from unauthorized access and attacks. Common
        cybersecurity measures include firewalls, antivirus software, encryption programs,`,
    },

]